import { Record } from 'immutable';

export default class EventRecord extends Record({
  id: null,
  content: null,
  createdAt: null,
  createdBy: null,
  date: undefined,
  entity: undefined,
  files: undefined,
  flaggedAt: undefined,
  flaggedBy: undefined,
  flaggedStatus: undefined,
  links: undefined,
  parameters: undefined,
  type: null,
}) {
}
